import { FC, useMemo, CSSProperties, } from "react";
import classNames from "classnames";
import { ScanPageContentCountProps, ScanPageContentItemEnum, } from "../../interface";

const Count: FC<ScanPageContentCountProps> = props => {
  const { className, style, title, subTitle, header, addonBefore, addonAfter, count, countType, unit, isNumber, fontSize, countClassName, countStyle, } = props;
  const classes = classNames('body-content-count', className);
  const countClasses = classNames('body-container', countClassName, {
    'body-container-number': isNumber,
    'text-danger': countType === 'danger',
    'text-primary': countType === 'primary',
    'text-success': countType === 'success',
    'text-warning': countType === 'warning',
  });
  const newCountStyle: CSSProperties = useMemo(() => {
    const newStyle: CSSProperties = {...countStyle};
    if (fontSize) newStyle.fontSize = `${fontSize}px`;
    return newStyle;
  }, [fontSize, countStyle]);
  return (
    <div className={classes} style={style}>
      <div className="body-content-count-header">
        <div className="count-header-left yb-card-item-head">
          {addonBefore}
          <div className="count-header-left-title">{title}</div>
          <div className="count-header-left-sub-title">{subTitle}</div>
        </div>
        <div>{addonAfter}</div>
      </div>
      {header}
      <div className='body-content-count-body'>
        <div className='body-container-wrapper'>
          <div className={countClasses} style={newCountStyle}>{count}</div>
          {!!unit && <div className="body-unit">{unit}</div>}
        </div>
      </div>
    </div>
  );
};

Count.displayName = ScanPageContentItemEnum.ContentCount;

export default Count;